import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tooltip"
export default class extends Controller {
  connect() {
    this.$element = $(this.element)
    this.$element.tooltip({ html: true })
    this.element.addEventListener('click', () => this.$element.tooltip('hide'))
  }
}
